import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { EquipmentServices } from '../shared/services/equipment.service';
import { Equipment } from '../shared/interfaces/equipment';


@Component({
  selector: 'app-equipments',
  templateUrl: './equipment.component.html',
  styleUrls: ['./equipment.component.scss']
})
export class EquipmentComponent implements OnInit {


  equipments: Equipment[];
  equipment: Equipment;
  selectedEquipments: Equipment[] = [];

  equipmentDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private equipmentService: EquipmentServices,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Equipments'}
    ];

    this.equipments = [];
    this.equipment = { } as Equipment;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.equipmentService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.equipments = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Equipment = jsonItem as Equipment;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.equipments.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.equipmentService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.equipments);
            doc.save('equipments.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.equipments);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "equipments");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
      });
      exportCols.push('position');
      this.exportService.exportToCsv(this.selectedEquipments, 'equipments', exportCols);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.equipment = {} as Equipment;
    this.submitted = false;
    this.equipmentDialog = true;
  }

  deleteSelectedEquipment() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected equipments?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.equipments = this.equipments.filter(val => !this.selectedEquipments.includes(val));
            
            this.selectedEquipments.forEach( equipment => this.equipmentService.delete(equipment.$key));
            this.selectedEquipments = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Equipment Deleted', life: 3000});
        }
    });
  }

  editEquipment(equipment: Equipment) {
    this.equipment = {...equipment};
    this.equipmentDialog = true;
  }

  deleteEquipment(equipment: Equipment) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + equipment.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.equipments = this.equipments.filter(val => val.$key !== equipment.$key);
            this.equipment = {} as Equipment;
            this.equipmentService.delete(equipment.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Equipment Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.equipmentDialog = false;
    this.submitted = false;
  }

  saveEquipment() {
    this.submitted = true;

    if ( this.equipment.name.trim() ) {
      this.equipment.isEnabled = true;
      
      if (this.equipment.$key) {
          this.equipments[this.findIndexById(this.equipment.$key)] = this.equipment;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Equipment Updated', life: 3000});
          this.equipmentService.update(this.equipment);
        } else {
          this.equipment.position = this.equipments.length;
          this.equipmentService.add(this.equipment);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Equipment Created', life: 3000});
      this.equipments = [...this.equipments];
    }

    this.equipmentDialog = false;
    this.equipment = { } as Equipment;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.equipments.length; i++) {
        if (this.equipments[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeEquipment(equipment : Equipment) {
    this.equipmentService.update(equipment);
  }

  completePosition(equipment : Equipment) {
    if ( this.newPosition > -1 ) {
        equipment.position = this.newPosition;
        equipment = this.checkPositionLimits(equipment);
        this.reorderElements(equipment);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.equipments.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.equipments.length - 1 - event.dropIndex;
    const equipmentToMove = this.equipments[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.equipments[index] = this.equipments[index+1];
        this.equipments[index].position = index;
        this.equipmentService.update(this.equipments[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.equipments[index] = this.equipments[index-1];
        this.equipments[index].position = index;
        this.equipmentService.update(this.equipments[index]);
      }
    } 
    this.equipments[endIndex] = equipmentToMove;
    this.equipments[endIndex].position = endIndex;
    this.equipmentService.update(this.equipments[endIndex]);
  }

  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
  }; field: string; order: number; 
  }) => {
        if (data && data.filteredValue) {
          this.isFilter = !(this.equipments.length === data.filteredValue['length']);
        } else {
          this.isFilter = false;
        }
    });
    
  }


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, equipment: Equipment) {
    // console.log("event" +event);
    if (equipment.position != null && equipment.position > -1) {
      this.previousPosition = equipment.position;
      this.newPosition = event;
    }
   
  }

  checkPositionLimits(equipment: Equipment) {
    console.log('check ',equipment.position + ' ' + this.equipments.length);
    if (!equipment.position) {
     // console.log('check 1');
      return this.equipment;
    }
    if (equipment.position < 0) {
      equipment.position = 0;
      // console.log('check 2');
      return equipment;
    }
    if (equipment.position > this.equipments.length) {
      equipment.position = this.equipments.length - 1;
      return equipment;
    }
   // console.log('check 4');
    return equipment;
  }

  async reorderElements(equipment: Equipment) {
    this.newPosition = this.newPosition  > this.equipments.length ? this.equipments.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === equipment.position ) {
      return;
    }
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const equipmentToMove = this.equipments[startIndex];
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.equipments);
        console.log('Item to +1: ', this.equipments[index+1]);

        this.equipments[index] = this.equipments[index+1];
        this.equipments[index].position = index;
        this.equipmentService.update(this.equipments[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.equipments[index] = this.equipments[index-1];
        this.equipments[index].position = index;
        this.equipmentService.update(this.equipments[index]);
      }
    } 
    this.equipments[endIndex] = equipmentToMove;
    this.equipments[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.equipmentService.update(this.equipments[endIndex]);
  }
}